/* Ürün sayfası: galeri thumbnail değişimi + adet sayacı */
(function () {
  'use strict';

  // Galeri: thumbnail'a tıklayınca ana görseli değiştir
  const main = document.getElementById('ProductMainImage');
  document.querySelectorAll('[data-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const src = thumb.getAttribute('data-thumb');
      if (main && src) {
        main.src = src;
        main.removeAttribute('srcset');
      }
      document.querySelectorAll('[data-thumb]').forEach((t) => t.classList.toggle('is-active', t === thumb));
    });
  });

  // Adet sayacı
  document.querySelectorAll('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('[data-qty-input]');
    if (!input) return;
    wrap.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    wrap.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });

  // Mobil sticky sepete-ekle çubuğu: ana buton görünüm dışına çıkınca göster
  const sticky = document.querySelector('[data-product-sticky]');
  const mainBuy = document.querySelector('.product__buy');
  if (sticky && mainBuy && 'IntersectionObserver' in window) {
    const show = (on) => {
      sticky.hidden = !on;
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      sticky.classList.toggle('is-visible', on);
    };
    const observer = new IntersectionObserver(
      (entries) => { show(!entries[0].isIntersecting); },
      { rootMargin: '0px 0px -40% 0px' }
    );
    observer.observe(mainBuy);
  }
})();
